import ReactSpeedometer from "react-d3-speedometer";
const Speedometer = (props) => {
  return (<ReactSpeedometer width={330} height={200}
    needleHeightRatio={0.8} maxValue={100}
    value={props.averagePercentage} ringWidth={40}
    customSegmentStops={[0, 40, 80, 100]}
    segmentColors={['#FF2A2A', '#F39C12', '#39C560']}
    currentValueText={`${props.averagePercentage}%`}
    customSegmentLabels={[
      { text: '0-40%', position: 'INSIDE', color: '#FFFFFF', },
      { text: '41-80%', position: 'INSIDE', color: '#FFFFFF', },
      { text: '81-100%', position: 'INSIDE', color: '#FFFFFF', },
    ]}
    needleTransitionDuration={3333}
    needleTransition="easeElastic"
    needleColor={'#272525'} textColor={'#201E1E'}
  />
  );
}
export default Speedometer;